

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {

  1: { // Exercise num
    unit: 'Review 3',
    id: 'SB4-PV3-P70-E1',
    audio: '',
    video: '',
    component: D1,
    textAlign: 'center',
    padding: 0,
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page70/E1/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page70/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page70/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/3.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page70/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/5.jpg', input: true, answer: "y" },
        { url: 'img/FriendsPlus/Page70/E1/6.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page70/E1/7.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page70/E1/8.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page70/E1/9.jpg', input: true, answer: "u" },
        { url: 'img/FriendsPlus/Page70/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/11.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page70/E1/12.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page70/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/14.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page70/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/17.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page70/E1/18.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page70/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/20.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page70/E1/21.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page70/E1/22.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page70/E1/23.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/24.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page70/E1/25.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/26.jpg', input: true, answer: "f" },
        { url: 'img/FriendsPlus/Page70/E1/27.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page70/E1/28.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/29.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page70/E1/30.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/31.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page70/E1/32.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/33.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page70/E1/34.jpg', input: true, answer: "v" },
        { url: 'img/FriendsPlus/Page70/E1/35.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page70/E1/36.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page70/E1/37.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page70/E1/38.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/39.jpg', input: true, answer: "f" },
        { url: 'img/FriendsPlus/Page70/E1/40.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/41.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page70/E1/42.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page70/E1/43.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/44.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page70/E1/45.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/46.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page70/E1/47.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page70/E1/48.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/49.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page70/E1/50.jpg', input: true, answer: "m" },
        { url: 'img/FriendsPlus/Page70/E1/51.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page70/E1/52.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page70/E1/53.jpg' },
        { url: 'img/FriendsPlus/Page70/E1/54.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page70/E1/55.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page70/E1/56.jpg' },
      ],


    ],
  },

  2: { // Exercise num
    unit: 'Review 3',
    id: 'SB4-PV3-P70-E2',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page70/E2/Key/answerKey.png',
    questionImage: [ // Row      
      [
        // Column1
        { url: 'img/FriendsPlus/Page70/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page70/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/3.jpg', input: true, answer: "shopping mall" },
        { url: 'img/FriendsPlus/Page70/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page70/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/6.jpg', input: true, answer: "movie theatre" },
        { url: 'img/FriendsPlus/Page70/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page70/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/9.jpg', input: true, answer: "café/cafe" },
        { url: 'img/FriendsPlus/Page70/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page70/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page70/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page70/E2/13.jpg', input: true, answer: "library" },
        { url: 'img/FriendsPlus/Page70/E2/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page70/E2/15.jpg' },
      ],

    ],
  },
  3: { // Exercise num
    unit: 'Review 3',
    id: 'SB4-PV3-P70-E3',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page70/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page70/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page70/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page70/E3/3.jpg', input: true, answer: "never" },
        { url: 'img/FriendsPlus/Page70/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page70/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page70/E3/6.jpg', input: true, answer: "always" },
        { url: 'img/FriendsPlus/Page70/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page70/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page70/E3/9.jpg', input: true, answer: "sometimes" },
        { url: 'img/FriendsPlus/Page70/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page70/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page70/E3/12.jpg', input: true, answer: "always" },
        { url: 'img/FriendsPlus/Page70/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page70/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page70/E3/15.jpg', input: true, answer: "never" },
        { url: 'img/FriendsPlus/Page70/E3/16.jpg' },
      ],


    ],
  },



}
export default json;
